import React, { useState ,useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer ,toast} from 'react-toastify';
import { useAuthHandling } from '../useAuthhandling';
import Cookies from 'js-cookie';
import Suspendmodal from '../Suspendmodal';
import ReactPaginate from 'react-paginate';
import Config from '../Config';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import { FaSearch } from 'react-icons/fa';
import { IoArrowBack } from 'react-icons/io5';
import Nodatafound from '../Nodatafound';

function Professionaluserlist() {

    const { isAuthorized, handleUnauthorized } = useAuthHandling();

    let navigate = useNavigate();
    const tokens = Cookies.get("a_token");
    if (!tokens) {
      navigate("/");
    }
    const [customerdata, setCustomer] = useState([]);
    const[paginate,setPaginate]=useState('');
    const [pagenum,setPagenum]=useState(1);
    const[pageindex,setPageindex]=useState(1);
    const [search, setSearch] = useState('');

    const [modal_animationFlip, setmodal_animationFlip] = useState(false);
    const [pageid, setPageid] = useState("");
  
    function tog_animationFlip(id) {
      setmodal_animationFlip(!modal_animationFlip);
      setPageid(id)
    }


    const getinfo = async (e) => {
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/user/search-professionals?searchTerm=${search}&page=1`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        }
      );
      if (res.status === 200 ) {
        const data = await res.json();
  
        setCustomer(data.data[0].data);
        setPaginate(data.data[0].totalPages);
  
      } 
      else if(res.status === 401){
        handleUnauthorized();
        getinfo();
      }
      else {
        alert("error");
  
      }
    };
  
    // const getinfo = async (e) => {
    //   const res = await fetch(
    //     `${Config.apiurl}/api/v1/crm/professional/get-professionals?page=1`,
    //     {
    //       method: "GET",
    //       headers: {
    //         Authorization: `Bearer ${Cookies.get("a_token")}`,
    //       },
    //     }
    //   );
    //   if (res.status === 200) {
    //     const data = await res.json();
  
    //     setCustomer(data.data[0].data);
    //     setPaginate(data.data[0].total_pages);
    //   }
    //   else if(res.status === 401){
    //     handleUnauthorized();
    //   }
    //   else {
    //     toast.error("Something went wrong!", {
    //       position: "top-center",
    //       autoClose: 1500,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //     });
    //     <ToastContainer />;
    //   }
    // };
    useEffect(() => {
      getinfo();
    }, [search]);
  
    const DeleteData = async (id) => {
      setmodal_animationFlip(false);
  
      // const response = await fetch(
      //   `${Config.apiurl}/api/v1/crm/professional/delete-professional/${id}`,
      //   {
      //     method: "PUT",
      //     headers: {
      //       Authorization: `Bearer ${Cookies.get("a_token")}`,
      //     },
      //   }
      // );
  
  
       const response = await fetch(
        `${Config.apiurl}/api/v1/crm/professional/suspended-professional/${id}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        }
      );
      const deletedata = await response.json();
  
      if (response.status === 200) {
        toast.success("Suspended Sucessfully!", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        handlePageClick(pagenum);
  
        
      } 
      else if(response.status === 401){
        handleUnauthorized();
        DeleteData(id);
      }
      else {
        toast.error("Something went wrong!", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        <ToastContainer />;
  
      }
    };
  
  
    let handleChangetoggverify = async(id) => {
      const response = await fetch(
        `${Config.apiurl}/api/v1/crm/professional/professional-verify-update/${id}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        }
      );
      if (response.status === 200) {
        const verifydata = await response.json();
  
        toast.success("Professional Verified Updated!", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
  
        handlePageClick(pagenum);
  
       
      } 
      else if(response.status === 401){
        handleUnauthorized();
        handleChangetoggverify(id);
      }
      else {
        toast.error("Something went wrong!", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        <ToastContainer />;
      }
  
    }
    let handleChangetoggfeatured = async(id) => {
  
      const response = await fetch(
        `${Config.apiurl}/api/v1/crm/professional/professional-featured-update/${id}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        }
      );
  
  
      if (response.status === 200 ) {
        const verifydata = await response.json();
  
        toast.success("Professional Featured Updated!", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
  
        handlePageClick(pagenum);
        
      } 
      else if(response.status === 401){
        handleUnauthorized();
        handleChangetoggfeatured();
      }
      else {
        toast.error("Something went wrong!", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        <ToastContainer />;
      }
  
    }
  
  
    const fetchComments = async (currentPage) => {
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/user/search-professionals?searchTerm=${search}&page=${currentPage}`,
        // `${Config.apiurl}/api/v1/crm/professional/get-professionals?page=${currentPage}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        }
      );
      if (res.status === 200 ) {
  
      const data = await res.json();
      return data.data[0].data;
    }
      else if(res.status === 401){
        handleUnauthorized();
        fetchComments(currentPage);
      }
    };
  
    const handlePageClick = async (data) => {
      if(data===1){
        setPageindex(1);
  
        setPagenum(data);
        const commentsFormServer = await fetchComments(data);
        setCustomer(commentsFormServer);
      }
      else{
      let currentPage = data.selected + 1;
      setPageindex(currentPage);
  
      setPagenum(data);
      const commentsFormServer = await fetchComments(currentPage);
  
      setCustomer(commentsFormServer);
      }
      
    };
  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">

          <div className='user_list_search_all'>

<div className='user_all_list-head user_all_list-head_new'>
  <Link to="/userlist" className='list_back_btn'  >
<IoArrowBack />
</Link>
    <Link className='user_all_list-head_a' to="/professionaladd">Create Professional</Link>
</div>
<div className='user_list_search'>
    <input  value={search} onChange={(e)=>setSearch(e.target.value)}/>
    <FaSearch />
</div>

</div>



    <div className="row">
    <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
            <div className="card-body">
                <h4 className="card-title">Professional List</h4>

                <div className="table-responsive pt-3">
                  {customerdata?.length>0?
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Sl No</th>
                                <th>Name</th>

                                <th>Contact Number</th>

                                <th>Category</th>
                                <th>Verified</th>
                                <th>Featured</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {customerdata.map((element, i) => {
                                return (
                                    <>
                                        
                                            <tr>
                                                <th scope="row">{pageindex === 1 ? i + 1 : (pageindex - 1) * 10 + i + 1}</th>
                                                <td>{element.name}</td>

                                                <td>{element.mobile}</td>

                                                <td>{element.professionalCategoryName}</td>
                                                <td>
                                                    <span
                                                        className="form-checks form-switch form-switch-lg mb-3"
                                                        dir="ltr"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            name="verify"
                                                            className="form-check-input "
                                                            value={element.verified}
                                                            checked={element.verified === true ? true : false}
                                                            onChange={(e) => handleChangetoggverify(element._id)}
                                                        />
                                                    </span>
                                                </td>
                                                <td>
                                                    <span
                                                        className="form-checks form-switch form-switch-lg mb-3"
                                                        dir="ltr"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            name="featured"
                                                            className="form-check-input "
                                                            value={element.featured}
                                                            checked={element.featured === true ? true : false}
                                                            onChange={(e) => handleChangetoggfeatured(element._id)}

                                                        />
                                                    </span>
                                                </td>

                                                <td className='actions_td'>
                                                    <Link
                                                        // onClick={() =>
                                                        //   deletecustomer(element.userId._id)
                                                        // }
                                                        className='action_icons'
                                                        onClick={() => tog_animationFlip(element._id)}
                                                    >
                                                        <i className="fa-solid fa-trash" />
                                                    </Link>

                                                    <Link
                                                        to={`/editprofessional/${element._id}`}
                                                        className="fa-solid fa-pen action_icons"

                                                    ></Link>

                                                    <Link to={"/userview/" + element._id}
                                                     state={{
                                                        type: "professional-user"

                                                    }}

                                                    className="action_icons" >
                                                        <i className="fa-solid fa-eye" />
                                                    </Link>
                                                    <ToastContainer />
                                                </td>
                                            </tr>
                                           
                                    </>
                                );
                            })}
                        </tbody>
                    </table>
                    :
                    <Nodatafound/>
                  }
                </div>
            </div>
        </div>
    </div>
</div>

{paginate > 1 ? (
                <ReactPaginate
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  pageCount={paginate}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              ) : (
                ""
              )}
          </div>
        </div>

        {modal_animationFlip ? (
          <Suspendmodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"Professional"}
          />
        ) : (
          ""
        )}
      </div>
    </div>


  )
}

export default Professionaluserlist
